import React, { FC } from "react";
import { Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface BurnSootIndexAdornmentProps {
  value: number;
}

export const BurnMaxTemperatureAdornment: FC<BurnSootIndexAdornmentProps> = (
  props
) => {
  const { t } = useTranslation("firefly-shared-ts-domain");
  return (
    <Tooltip title={t("Max Temperature")} arrow placement={"top-start"}>
      <Typography>{props.value}</Typography>
    </Tooltip>
  );
};
